import { produce } from 'immer';
import {
  LOADING_STATUS,
  QUESTION_ANSWERED,
  RESET_STATUS,
  SAVING_STATUS,
  SAVING_STATUS_FAILED,
  STATUS_LOADED,
  STATUS_LOADING_FAILED,
  STATUS_SAVED,
  SURVEY_STARTED,
  SUBMITTING_SURVEY,
  SUBSTANCE_USE_QUESTIONNAIRE_SKIPPED,
  SURVEY_SUBMISSION_FAILED,
  SURVEY_SUBMITTED
} from "redux/checkIn/actions";
import { scoreCRAFFT } from "services/scoring";

export const initialState = {
  loading: true,
  lastLoadingError: null,
  status: {
    answers: {},
    submitted: null,
    hiddenCards: {},
  },
  previousStatus: {},
  statusMeta: {
    answersResponseId: null,
    answersETag: null,
    hiddenCardsResponseId: null,
    hiddenCardsETag: null
  },
  saving: false,
  lastSavingFailure: null,
  surveyStarted: false,
  submittingSurvey: false,
  submissionSuccessful: null,
  lastSubmissionFailure: null,
  alreadySubmitted: false,
}

const checkIn = (state = initialState, action) => produce(state, draft => {
  switch (action.type) {
    case RESET_STATUS:
      return initialState
    case QUESTION_ANSWERED:
      const { groupLinkId, linkId, fhirAnswer } = action.payload
      draft.status.answers[groupLinkId] ||= {}
      draft.status.answers[groupLinkId][linkId] = fhirAnswer
      if (scoreCRAFFT(draft.status.answers.CQ) === 0) delete draft.status.answers.BSCQ
      break
    case LOADING_STATUS:
      draft.loading = true
      draft.lastLoadingError = null
      break
    case STATUS_LOADED:
      draft.status = action.payload.status
      draft.statusMeta = action.payload.statusMeta
      draft.previousStatus = draft.status
      draft.loading = false
      draft.lastLoadingError = null
      draft.alreadySubmitted = draft.status.submitted
      break
    case STATUS_LOADING_FAILED:
      draft.loading = false
      draft.lastLoadingError = action.payload
      break
    case SURVEY_STARTED:
      draft.surveyStarted = true
      break
    case SAVING_STATUS:
      draft.saving = true
      draft.lastSavingFailure = null
      break
    case STATUS_SAVED:
      draft.statusMeta.answersETag = action.payload.answersETag
      draft.statusMeta.hiddenCardsETag = action.payload.hiddenCardsETag
      draft.previousStatus = action.payload.savedStatus
      draft.saving = false
      break
    case SAVING_STATUS_FAILED:
      draft.saving = false
      draft.lastSavingFailure = action.payload
      break
    case SUBSTANCE_USE_QUESTIONNAIRE_SKIPPED:
      delete draft.status.answers.CQ
      delete draft.status.answers.BSCQ
      break
    case SUBMITTING_SURVEY:
      draft.status.submitted = true
      draft.submittingSurvey = true
      draft.lastSubmissionFailure = null
      break
    case SURVEY_SUBMITTED:
      draft.submittingSurvey = false
      draft.submissionSuccessful = true
      break
    case SURVEY_SUBMISSION_FAILED:
      draft.status.submitted = false
      draft.submittingSurvey = false
      draft.lastSubmissionFailure = action.payload
      break
    default:
  }
})
export default checkIn
